export const EXAMINATION_CENTER_STEP_ROUTE = 'osrodek-egzaminacyjny';
export const EXAMINATION_CENTER_STEP_PARAMETRIZED_ROUTE = ':id/osrodek-egzaminacyjny';
